module.exports = __webpack_public_path__ + "static/media/emp_app.08ec1d18.svg";